import { useState, useEffect, forwardRef } from "react";
import { InputDatePickerNewStyled } from "./styled";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import th from "date-fns/locale/th";
import { Icons } from "components";
import { Months } from "utils/constants";

const InputDatePickerNew = ({
  theme_standard,
  value,
  onChange,
  disabled,
  minDate,
  maxDate,
  format = "DD MMMM YYYY",
  buddhistYear = false,
  showMonthYearPicker = false,
  iconColor = "#002366",
  placeholder,
}) => {
  const [_value, _setValue] = useState();


  const formatDate = (date, format, buddhistYear) => {
    if (!date) return "";
    const m = moment(date);
    if (buddhistYear) {
      const year = m.year() + 543;
      const month = Months.find((mo) => mo.value === m.format("MM"))?.th || "";
      return format
        .replace("YYYY", year)
        .replace("MMMM", month)
        .replace("DD", m.format("DD"));
    }
    return m.format(format);
  };

  const CustomInput = forwardRef(({ displayText, iconColor, onClick }, ref) => (
    <button type="button" className="picker_button" onClick={onClick} ref={ref}>
      <span className="picker_text">{displayText}</span>
      <span className="picker_icon">
        <Icons.Calendar3 color={iconColor} />
      </span>
    </button>
  ));

  useEffect(() => {
    if (value) _setValue(new Date(value));
  }, [value]);

  return (
    <InputDatePickerNewStyled disabled={disabled}>
      <div className={theme_standard ? "theme_standard" : ""}>
        <DatePicker
          selected={_value}
          onChange={(e) => onChange && onChange(e)}
          dateFormat="dd/MM/yyyy"
          minDate={minDate}
          maxDate={maxDate}
          customInput={
            <CustomInput
              displayText={
                !_value && placeholder
                  ? placeholder
                  : formatDate(_value, format, buddhistYear)
              }
              iconColor={disabled ? "#989898" : iconColor}
            />
          }
          disabled={disabled}
          locale={th}
          showMonthYearPicker={showMonthYearPicker}
          showFullMonthYearPicker={showMonthYearPicker}
          dropdownMode="select"
        />
      </div>
    </InputDatePickerNewStyled>
  );
};

export default InputDatePickerNew;
